import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { useVoucherAssigneeOptions } from '@/composables/useVoucherAssigneeOptions';
    import { splitAssigneeIds } from '@/utils/voucherAssignees';
    import { watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAssignAssignedForm',
  props: {
    form: {},
    companyId: {}
  },
  setup(__props: any) {

    const props = __props;

    const { assigneeOptions, isLoadingAssigneeOptions, dedupeAssigneeIds } =
        useVoucherAssigneeOptions(props.companyId);

    watch(
        () => props.form.assignee_ids,
        (assigneeIds) => {
            const deduped = dedupeAssigneeIds(assigneeIds ?? []);

            if (JSON.stringify(deduped) !== JSON.stringify(assigneeIds ?? [])) {
                props.form.assignee_ids = deduped;

                return;
            }

            const { employee_ids, user_ids } = splitAssigneeIds(deduped);
            props.form.employee_ids = employee_ids;
            props.form.user_ids = user_ids;
        },
        { deep: true },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "assignee_ids",
      label: "vouchers.select.assign_confirm.assigned"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.assignee_ids,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.assignee_ids) = $event)),
          options: _unref(assigneeOptions),
          "label-by": "label",
          "value-by": "id",
          "show-remove-button": false,
          loading: _unref(isLoadingAssigneeOptions)
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})